import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { formatDate } from '@angular/common';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { DeadlineService } from '../../../../services/deadline.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../services/general.service';


//import components
import { DeadlineCreateComponent } from '../deadline-create/deadline-create.component';

import { DeadlineGeneralComponent } from '../deadline-view/deadline-general/deadline-general.component';
import { DeadlineViewDeadComponent } from '../deadline-view/deadline-viewdead/deadline-viewdead.component';
import { DeadlineActionComponent } from '../deadline-view/deadline-action/deadline-action.component';
import { DeadlineOccurrenceComponent } from '../deadline-view/deadline-occurrence/deadline-occurrence.component';

declare var $: any;

@Component({
  selector: 'app-deadline-view',
  templateUrl: './deadline-view.component.html',
  styleUrls: ['./deadline-view.component.css']
})
export class DeadlineViewComponent implements OnDestroy, OnInit {

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableCols1: any;
  // datatableAddCols1: any;

  @Input()  filter1: string;
  @Input()  filter2: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addDeadlineModal: BsModalRef;
  generalModal: BsModalRef;
  vdeadModal: BsModalRef;
  actionModal: BsModalRef;
  occurrenceDetailsModal: BsModalRef;
  deleteOption: any;

  lang: any;
  records: any;
  deadline_data: any;
  occ_details: any;
  occinfo: any;
  pageView: string = 'list';
  rolepermission: any;

  id: number;
  subs = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private deadlineService: DeadlineService,
    private modalService: BsModalService,
    private generalService: GeneralService,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router,
    private location: Location,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,

  ) { }

  ngOnInit() {

    var role = this.ngxRolesService.getRole('timetable');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }
    
    this.getData();

  //   this.subs.add(this.dragulaService.dropModel("records")
  //   .subscribe(({ sourceModel, targetModel, item }) => {
  //     let arr = []; let table = [];
  //     // console.log(sourceModel);
  //     for (let employee of sourceModel) {
  //       arr.push(employee.timetable_actionId)
  //     }
  //     this.updsorting(arr, table);
  //   })
  // );

    
    

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');
        
        table1
          .on('select deselect', function (e, dt, type, indexes) {
            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

          var buttons1 = new $.fn.dataTable.Buttons(table1, {
            dom: {
              button: {
                className: ''
              }
            },
            buttons: [
              {
                extend: 'csv',
                text: this.lang.exportCsv,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadlines "+ this.deadline_data.timetable_discrption +" Archive "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'pdfHtml5',
                text: this.lang.exportPdf,
                className: 'btn btn-info',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadlines "+ this.deadline_data.timetable_discrption +" Archive "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'excel',
                text: this.lang.exportExcel,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadlines "+ this.deadline_data.timetable_discrption +" Archive "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'print',
                text: this.lang.exportPrint,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadlines "+ this.deadline_data.timetable_discrption +" Archive "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
            ], select: true
          }).container().appendTo($('#datatableExportBtn1'));
        
    
      }
    }

    this.filter1 = '';
    this.filter2 = '';

  }

  datatableColumns(): void{

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
      // {
      //   targets: 13,
      //   visible: false,
      //   orderable: false,
      // },
    ];

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: this.lang.executionData, isSelected: false },
      { id: 4, value: this.lang.performer, isSelected: false },
      { id: 6, value: this.lang.outcome, isSelected: false },
      { id: 5, value: this.lang.description, isSelected: false },
      { id: 8, value: this.lang.option, isSelected: false },
      { id: 9, value: this.lang.nextDeadline, isSelected: false },
      { id: 10, value: this.lang.referringDate, isSelected: false },
      { id: 11, value: this.lang.attachments, isSelected: false },
    ];

    // this.datatableAddCols1 = [
    //   { id: 13, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableFilter(): void{

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[3] || '';
      const filt2 = data[6] || '';
      

      var status = true;

      if (this.filter1 && filt1 != this.filter1)
        status = false;
      if (this.filter2 && filt2 != this.filter2)
        status = false;
      
      return status;
    });

  }

  datatableFilterAction(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  getData() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.deadlineService.view(this.id)
        .subscribe(
          (res) => {
            this.lang = this.deadlineService.actionLang(res);

            this.records = res.data.interventions;
            this.deadline_data = res.data.deadline_data;
            this.occ_details = res.data.occ_details;

            if (this.occ_details.length == 0) {
              this.occinfo = '';
            }
            else
            {
              this.occinfo = '1';
              }

            //load datatable
            this.datatableConfig();

            this.datatableFilter();

          }
        );
    });
  }

  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++)
      this.datatableCols1[i].isSelected = selected;
    
    // for (var i = 0; i < this.datatableAddCols1.length; i++)
    //   this.datatableAddCols1[i].isSelected = selected;

    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    // for (var i = 0; i < this.datatableAddCols1.length; i++) {
    //   if (this.datatableAddCols1[i].id == id)
    //     this.datatableAddCols1[i].isSelected = selected;
    // }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

    // for (var i = 0; i < this.datatableAddCols1.length; i++) {
    //   if (this.datatableAddCols1[i].isSelected)
    //     table1.column(parseInt(this.datatableAddCols1[i].id)).select();
    //   else
    //     table1.column(parseInt(this.datatableAddCols1[i].id)).deselect();
    // }

  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.DEADLINE_VIEW+'/'+this.id]);
    });
  }
  
  success(msg: any) {
    
    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    this.redirect();
  }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }
  
  add(ID) {
    // console.log(this.lang);
    this.generalModal = this.modalService.show(DeadlineGeneralComponent, { initialState: {'ID': ID,'langs': this.lang} });
  }
    

  viewdead() {
    // console.log(this.lang);
    this.vdeadModal = this.modalService.show(DeadlineViewDeadComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });
    
    // this.vdeadModal = this.modalService.show(DeadlineViewDeadComponent, { class: 'modal-lgs' });



  }
    

  newaction(DID) {
    this.actionModal = this.modalService.show(DeadlineActionComponent, {  initialState: {'DID': DID,'langs': this.lang} });
  }

  edit(ID, DID) {
    // console.log(ID); 
    this.actionModal = this.modalService.show(DeadlineActionComponent, { initialState: { 'ID': ID, 'DID': DID,'action':'edit','langs': this.lang} });
  }

  editdead(ID) {
    this.addDeadlineModal = this.modalService.show(DeadlineCreateComponent, { initialState: {'ID': ID, 'langs': this.lang, 'redirect': 'view'} });
  }
  occurrence_details(ID) {
    // console.log(ID);
    this.occurrenceDetailsModal = this.modalService.show(DeadlineOccurrenceComponent, { initialState: {'ID': ID, 'langs': this.lang} });
  }

  

  delete(ID, INID) {
    
    this.confirmationDialogService.confirm('Intervention Confirmation', 'Are you sure to remove this intervention?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed)
              return;

            this.deadlineService.interdelete(ID,INID)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
              });

    });
  }

  duplicate(ID, DID) {
  
    this.actionModal = this.modalService.show(DeadlineActionComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'DID': DID,'action': 'duplicate','langs': this.lang} });

    
    // this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate?')
    //     .subscribe(
    //       (confirmed) => {
            
    //         if (!confirmed)
    //           return;

    //         this.deadlineService.duplicate(ID)
    //         .subscribe(
    //           (res) => {
    //             if (res.status)
    //               this.success(res.msg);
    //             else
    //               this.error(res.msg);
    //         });

    // });


  }

  multiViewDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to remove all this.?')
      .subscribe(
        (confirmed) => {
          
          if (!confirmed)
            return;

          this.deadlineService.multiViewDelete(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
          });
      });
  }

  multiDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    console.log(selectedRows); return false;


    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
      .subscribe(
        (confirmed) => {
          
          if (!confirmed)
            return;

          this.deadlineService.multiDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
          });
      });

  }

  setPageView(view) {
    this.pageView = view;
  }

  // time_conversion(data) {
  //   return new Date(data.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
  // }
  backClicked() {
    this.location.back();

  }



  // updsorting(data: any, table: any) {
  //   this.deadlineService.viewsorting(data, table)
  //     .subscribe(
  //       (res) => {
  //         if (res.status) {
  //           this.success(res.msg);

  //         }
  //         else {
  //           this.error(res.msg);

  //         }
  //       });
  // }

}
